import * as echarts from 'echarts'
import 'echarts-gl'
import { findAllAndCount } from '../../../../../api/home.js'

import $, { data } from 'jquery'
import china from './china.js'
import { cityNameData, provinceNameChineseToEng, cityNameChineseToEng } from './geoNameDictionary.js'
import national from '../../../../../mock/map/china.js'
var geoCoordMap = {}
national.features.forEach(item => {
  geoCoordMap[item.properties.name] = item.properties.center
})
// var geoCoordMap = {
//   '海门': [121.15, 31.89],
//   '鄂尔多斯': [109.781327, 39.608266],
//   '招远': [120.38, 37.35],
//   '舟山': [122.207216, 29.985295],
//   '齐齐哈尔': [123.97, 47.33],
//   '盐城': [120.13, 33.38],
//   '赤峰': [118.87, 42.28],
//   '青岛': [120.33, 36.07],
//   '乳山': [121.52, 36.89],
//   '金昌': [102.188043, 38.520089],
//   '泉州': [118.58, 24.93],
//   '莱西': [120.53, 36.86],
//   '日照': [119.46, 35.42],
//   '胶南': [119.97, 35.88],
//   '南通': [121.05, 32.08],
//   '拉萨': [91.11, 29.97],
//   '云浮': [112.02, 22.93],
//   '梅州': [116.1, 24.55],
//   '文登': [122.05, 37.2],
//   '上海市': [121.48, 31.22],
//   '攀枝花': [101.718637, 26.582347],
//   '威海': [122.1, 37.5],
//   '承德': [117.93, 40.97],
//   '厦门': [118.1, 24.46],
//   '汕尾': [115.375279, 22.786211],
//   '潮州': [116.63, 23.68],
//   '丹东': [124.37, 40.13],
//   '太仓': [121.1, 31.45],
//   '曲靖': [103.79, 25.51],
//   '烟台': [121.39, 37.52],
//   '福州': [119.3, 26.08],
//   '瓦房店': [121.979603, 39.627114],
//   '即墨': [120.45, 36.38],
//   '抚顺': [123.97, 41.97],
//   '玉溪': [102.52, 24.35],
//   '张家口': [114.87, 40.82],
//   '阳泉': [113.57, 37.85],
//   '莱州': [119.942327, 37.177017],
//   '湖州': [120.1, 30.86],
//   '汕头': [116.69, 23.39],
//   '昆山': [120.95, 31.39],
//   '宁波': [121.56, 29.86],
//   '湛江': [110.359377, 21.270708],
//   '揭阳': [116.35, 23.55],
//   '荣成': [122.41, 37.16],
//   '连云港': [119.16, 34.59],
//   '葫芦岛': [120.836932, 40.711052],
//   '常熟': [120.74, 31.64],
//   '东莞': [113.75, 23.04],
//   '河源': [114.68, 23.73],
//   '淮安': [119.15, 33.5],
//   '泰州': [119.9, 32.49],
//   '南宁': [108.33, 22.84],
//   '营口': [122.18, 40.65],
//   '惠州': [114.4, 23.09],
//   '江阴': [120.26, 31.91],
//   '蓬莱': [120.75, 37.8],
//   '韶关': [113.62, 24.84],
//   '嘉峪关': [98.289152, 39.77313],
//   '广州市': [113.23, 23.16],
//   '延安': [109.47, 36.6],
//   '太原': [112.53, 37.87],
//   '清远': [113.01, 23.7],
//   '中山': [113.38, 22.52],
//   '昆明': [102.73, 25.04],
//   '寿光': [118.73, 36.86],
//   '盘锦': [122.070714, 41.119997],
//   '长治': [113.08, 36.18],
//   '深圳': [114.07, 22.62],
//   '珠海': [113.52, 22.3],
//   '宿迁': [118.3, 33.96],
//   '咸阳': [108.72, 34.36],
//   '铜川': [109.11, 35.09],
//   '平度': [119.97, 36.77],
//   '佛山': [113.11, 23.05],
//   '海口': [110.35, 20.02],
//   '江门': [113.06, 22.61],
//   '章丘': [117.53, 36.72],
//   '肇庆': [112.44, 23.05],
//   '大连': [121.62, 38.92],
//   '临汾': [111.5, 36.08],
//   '吴江': [120.63, 31.16],
//   '石嘴山': [106.39, 39.04],
//   '沈阳': [123.38, 41.8],
//   '苏州': [120.62, 31.32],
//   '茂名': [110.88, 21.68],
//   '嘉兴': [120.76, 30.77],
//   '长春': [125.35, 43.88],
//   '胶州': [120.03336, 36.264622],
//   '银川': [106.27, 38.47],
//   '张家港': [120.555821, 31.875428],
//   '三门峡': [111.19, 34.76],
//   '锦州': [121.15, 41.13],
//   '南昌': [115.89, 28.68],
//   '柳州': [109.4, 24.33],
//   '三亚': [109.511909, 18.252847],
//   '自贡': [104.778442, 29.33903],
//   '吉林': [126.57, 43.87],
//   '阳江': [111.95, 21.85],
//   '泸州': [105.39, 28.91],
//   '西宁': [101.74, 36.56],
//   '宜宾': [104.56, 29.77],
//   '呼和浩特': [111.65, 40.82],
//   '成都': [104.06, 30.67],
//   '大同': [113.3, 40.12],
//   '镇江': [119.44, 32.2],
//   '桂林': [110.28, 25.29],
//   '张家界': [110.479191, 29.117096],
//   '宜兴': [119.82, 31.36],
//   '北海': [109.12, 21.49],
//   '西安': [108.95, 34.27],
//   '金坛': [119.56, 31.74],
//   '东营': [118.49, 37.46],
//   '牡丹江': [129.58, 44.6],
//   '遵义': [106.9, 27.7],
//   '绍兴': [120.58, 30.01],
//   '扬州': [119.42, 32.39],
//   '常州': [119.95, 31.79],
//   '潍坊': [119.1, 36.62],
//   '重庆': [106.54, 29.59],
//   '台州': [121.420757, 28.656386],
//   '南京': [118.78, 32.04],
//   '滨州': [118.03, 37.36],
//   '贵阳': [106.71, 26.57],
//   '无锡': [120.29, 31.59],
//   '本溪': [123.73, 41.3],
//   '克拉玛依': [84.77, 45.59],
//   '渭南': [109.5, 34.52],
//   '马鞍山': [118.48, 31.56],
//   '宝鸡': [107.15, 34.38],
//   '焦作': [113.21, 35.24],
//   '句容': [119.16, 31.95],
//   '北京市': [116.46, 39.92],
//   '徐州市': [117.2, 34.26],
//   '衡水': [115.72, 37.72],
//   '包头': [110, 40.58],
//   '绵阳': [104.73, 31.48],
//   '乌鲁木齐': [87.68, 43.77],
//   '枣庄': [117.57, 34.86],
//   '杭州': [120.19, 30.26],
//   '淄博': [118.05, 36.78],
//   '鞍山': [122.85, 41.12],
//   '溧阳': [119.48, 31.43],
//   '库尔勒': [86.06, 41.68],
//   '安阳': [114.35, 36.1],
//   '开封': [114.35, 34.79],
//   '济南': [117, 36.65],
//   '德阳': [104.37, 31.13],
//   '温州': [120.65, 28.01],
//   '九江': [115.97, 29.71],
//   '邯郸': [114.47, 36.6],
//   '临安': [119.72, 30.23],
//   '兰州': [103.73, 36.03],
//   '沧州': [116.83, 38.33],
//   '临沂': [118.35, 35.05],
//   '南充': [106.110698, 30.837793],
//   '天津': [117.2, 39.13],
//   '富阳': [119.95, 30.07],
//   '泰安': [117.13, 36.18],
//   '诸暨': [120.23, 29.71],
//   '郑州': [113.65, 34.76],
//   '哈尔滨': [126.63, 45.75],
//   '聊城': [115.97, 36.45],
//   '芜湖': [118.38, 31.33],
//   '唐山': [118.02, 39.63],
//   '平顶山': [113.29, 33.75],
//   '邢台': [114.48, 37.05],
//   '德州': [116.29, 37.45],
//   '济宁': [116.59, 35.38],
//   '荆州': [112.239741, 30.335165],
//   '宜昌': [111.3, 30.7],
//   '义乌': [120.06, 29.32],
//   '丽水': [119.92, 28.45],
//   '洛阳': [112.44, 34.7],
//   '秦皇岛': [119.57, 39.95],
//   '株洲': [113.16, 27.83],
//   '石家庄': [114.48, 38.03],
//   '莱芜': [117.67, 36.19],
//   '常德': [111.69, 29.05],
//   '保定': [115.48, 38.85],
//   '湘潭': [112.91, 27.87],
//   '金华': [119.64, 29.12],
//   '岳阳': [113.09, 29.37],
//   '长沙': [113, 28.21],
//   '衢州': [118.88, 28.97],
//   '廊坊': [116.7, 39.53],
//   '菏泽': [115.480656, 35.23375],
//   '合肥': [117.27, 31.86],
//   '武汉': [114.31, 30.52],
//   '大庆': [125.03, 46.58],
//   '铜鼓县': [114.390232, 27.8223230]
// }


var convertData = function (data, provinceEngName, cityNameEng) {
  var res = []
  for (var i = 0; i < data.length; i++) {
    if (provinceEngName) {
      let ret = cityIsInclude(provinceEngName, data[i].name, cityNameEng)
      if (ret) {
        var geoCoord = geoCoordMap[data[i].name]
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value)
          })
        }
      }
    } else {
      let geoCoord = geoCoordMap[data[i].name]
      if (geoCoord) {
        res.push({
          name: data[i].name,
          value: geoCoord.concat(data[i].value)
        })
      }
    }
  }
  return res
}

let cityIsInclude = function (provinceEngName, cityName, cityNameEng) {
  let cities = cityNameData[`cityName_${provinceEngName}`]
  for (let city in cities) {
    if ((!cityNameEng && city.indexOf(cityName) !== -1) || (cityNameEng && city.indexOf(cityName) !== -1 && cities[city] === cityNameEng)) {
      return true
    }
  }
  return false
}



//   data= [
//   { name: '海门', value: 9 },
//   { name: '鄂尔多斯', value: 12 },
//   { name: '招远', value: 12 },
//   { name: '舟山', value: 12 },
//   { name: '齐齐哈尔', value: 14 },
//   { name: '盐城', value: 15 },
//   { name: '赤峰', value: 16 },
//   { name: '青岛', value: 18 },
//   { name: '乳山', value: 18 },
//   { name: '金昌', value: 19 },
//   { name: '泉州', value: 21 },
//   { name: '莱西', value: 21 },
//   { name: '潮州', value: 26 },
//   { name: '丹东', value: 27 },
//   { name: '太仓', value: 27 },
//   { name: '曲靖', value: 27 },
//   { name: '烟台', value: 28 },
//   { name: '福州', value: 29 },
//   { name: '瓦房店', value: 30 },
//   { name: '即墨', value: 30 },
//   { name: '抚顺', value: 31 },
//   { name: '玉溪', value: 31 },
//   { name: '寿光', value: 40 },
//   { name: '盘锦', value: 40 },
//   { name: '柳州', value: 54 },
//   { name: '三亚', value: 54 },
//   { name: '自贡', value: 56 },
//   { name: '吉林', value: 56 },
//   { name: '张家界', value: 59 },
//   { name: '宜兴', value: 59 },
//   { name: '北海', value: 60 },
//   { name: '西安', value: 61 },
//   { name: '金坛', value: 62 },
//   { name: '东营', value: 62 },
//   { name: '牡丹江', value: 63 },
//   { name: '遵义', value: 1 },
//   { name: '衡水', value: 80 },
//   { name: '包头', value: 80 },
//   { name: '绵阳', value: 80 },
//   { name: '乌鲁木齐', value: 84 },
//   { name: '枣庄', value: 84 },
//   { name: '杭州', value: 84 },
//   { name: '哈尔滨', value: 114 },
//   { name: '聊城', value: 116 },
//   { name: '芜湖', value: 117 },
//   { name: '唐山', value: 119 },
//   { name: '平顶山', value: 119 },
//   { name: '邢台', value: 119 },
//   { name: '德州', value: 120 },
//   { name: '济宁', value: 120 },
//   { name: '荆州', value: 127 },
//   { name: '宜昌', value: 130 },
//   { name: '合肥', value: 229 },
//   { name: '武汉', value: 273 },
//   { name: '大庆', value: 279 },
//   { name: '拉萨', value: 279 },
//   { name: '铜鼓县', value: 279 },
// ]

function MapDrillDown(echartDom, obj) {
  this.chartDom = echarts.init(echartDom)
  this.optionMap = null
  // tag: 0全国 1省 2市
  this.tag = 0
  this.timer = null
  this.provinceOrCityName = ''
  this.lastProvinceOrCityName = ''
  this.loadingObj = obj.$message
}

MapDrillDown.prototype = {
  // 设置区域颜色
  setRegions: function (regionsJson) {
    var colors = ['#083967', '#13548d', '#1c74b2']
    var colorsLen = colors.length
    var features = regionsJson.features
    var echatsRegions = []
    // var echatsRegions=[{
    //     name: '南海诸岛',
    //     value: 0,
    //     itemStyle: {
    //         normal: {
    //             opacity: 0,
    //             label: {
    //                 show: false
    //             }
    //         }
    //     }
    // }];

    for (var i = 0, len = features.length; i < len; i++) {
      var regionsItem = {
        name: features[i].properties.name,
        itemStyle: {
          normal: {
            // areaColor: colors[Math.floor(Math.random() * colorsLen)]
            areaColor: colors[Math.floor(Math.random() * colorsLen)]

          }
        }
      }
      echatsRegions.push(regionsItem)
    }
    return echatsRegions
  },
  setMap: function (dataM, count) {

    this.optionMap = {

      title: [
        {
          text: `中国综试区总数`,
          // text:`<span style="color: red;">测试</span>`,
          left: '33%',
          top:'70',
          textStyle: { //主标题 字体控制
            color: '#F1FAFF',
            fontSize: 28,
            fontFamily:'YouSheBiaoTiHei, YouSheBiaoTiHei'
          },
        },
        {
          // text: count,
          text:'196',
          left: '58%',
          top: '74',
          textStyle: { //主标题 字体控制
            color: '#FFC64B',
            fontSize: 24,
            lineHeight: 18,
            fontFamily:'YouSheBiaoTiHei, YouSheBiaoTiHei'


          },
        },
      ],
      visualMap: {
        // color: ['#C4127F', '#B7C400', '#38C467', '#C4B094', '#3A9EC4' ],
        type: 'piecewise',
        // top:"top",                                   //组件离容器上侧的距离,'top', 'middle', 'bottom','20%'
        right: "0",                               //组件离容器右侧的距离,'20%'
        // bottom:"auto",  
        textStyle: {
          color: '#639bc3'
        },
        pieces: [
          { min: 41, color: '#6D28D9' },
          { min: 31, max: 40, color: '#EC4899' },
          { min: 21, max: 30, color: '#33CCFF' },
          { min: 11, max: 20, color: 'orange' },
          { min: 6, max: 10, color: '#FF99FF' },
          { max: 5, color: '#BE185D' }
        ]

      },

      tooltip: {
        trigger: 'item',
        // triggerOn:'click', // 鼠标点击时触发
        enterable: true, // 鼠标是否能进入提示框内
        formatter: function (params) {
          var content = ''
          if (params.value !== undefined) {
            content = `<p style='text-align: center;min-width: 100px;'><span class='dpb' style='padding: 5px 8px;font-family: 微软雅黑;font-size: 18px;color: #ffffff;'>${params.name}</span><br></p>`
          }
          return `${params.name}:${params.value[2]}`
        }
      },
      geo: {
        type: 'map3D',
        map: 'china',
        boxDepth: 100, //地图倾斜度
        regionHeight: 3, //地图厚度
        zoom: 1.10, // 地图放大1.2倍
        roam: false, // 支持鼠标缩放和移动
        grid:{
          top: 0,
        },
        label: {
          normal: {
            show: true,
            color: '#639bc3'
          }
        },
        itemStyle: {

          emphasis: {
            areaColor: '#48c7ff' // 高亮效果
          },
          normal: {
            areaColor: '#083967',
            borderColor: '#48c7ff',
            // 一般情况，这里没有罗列底图高亮因为底图的高亮完全没有必要，我们是对地图操作，底图只是伪2d效果
            areaColor: 'rgba(200, 255, 200, 0.1)', // 区块颜色
            shadowColor: 'rgba(222, 222, 222, 1)', // 阴影颜色
            shadowBlur: 2, // 阴影模糊度
            shadowOffsetX: 1, // 阴影x轴偏移距离
            shadowOffsetY: 1, // 阴影y轴偏移距离
            borderWidth: 2 // 多边形边框宽度
          }
        }
      },
      series: [
        // {
        //   name: '',
        //   // type: 'effectScatter',
        //   type: 'scatter',
        //   coordinateSystem: 'geo',
        //   opacity: 1,
        //   data: convertData(dataM),
        //   // data: [],
        //   symbolSize: 12, // 散点图的大小
        //   label: {
        //   	normal: {
        //       show: false,
        //       formatter: function(params) {
        //         // return '{fline|客户：'+params+'  '+params+'}\n{tline|'+params+'}';
        //       },
        //       position: 'top',
        //       backgroundColor: 'rgba(254,174,33,.8)',
        //       padding: [0, 0],
        //       borderRadius: 3,
        //       lineHeight: 32,
        //       color: '#f7fafb',
        //       rich:{
        //         fline:{
        //           padding: [0, 10, 10, 10],
        //           color:'#ffffff'
        //         },
        //         tline:{
        //           padding: [10, 10, 0, 10],
        //           color:'#ffffff'
        //         }
        //       }
        //     },
        //   },
        //   itemStyle: {
        //     normal: {
        //       color: function(params){
        //         console.log(params.value[2])
        //       },
        //       borderColor: '#fff',
        //       borderWidth: 2
        //     },
        //     emphasis: {
        //       borderColor: '#fff',
        //       borderWidth: 2
        //     }
        //   }
        // },
        {
          name: '',
          type: 'scatter',
          //   type: 'effectScatter',
          coordinateSystem: 'geo',
          data: convertData(dataM),
          symbol: 'pin',
          color: '#f2d643', //颜色
          symbolSize: function (val) {
            return 40
            // return val[1];
          },
          symbolOffset: [1, 0],
          label: {
            show: true,
            fontStyle: 'normal',
            position: 'inside',
            color: '#fff',
            formatter: function (params) {
              return params.value[2];
            },
          }
        },

      ]
    }
    // 图表自适应
    window.addEventListener('resize', function () {
      this.chartDom.resize()
    }.bind(this))

    this.optionMap.geo.regions = this.setRegions(china) // 设置区域颜色
    this.chartDom.setOption(this.optionMap)
  },
  setClick: function () {
    return
    let that = this
    // 点击事件
    that.chartDom.on('click', function (params) { // 点击事件
      clearTimeout(that.timer)
      that.timer = setTimeout(function () {
        if (params.componentType === 'geo') { // 点击地图区域
          that.reFreshMap(params.name)
        }
      }, 300)
    })

    // 双击事件
    that.chartDom.on('dblclick', function (params) {
      clearTimeout(that.timer)
      that.tag = 0
      that.optionMap.series[0].data = convertData(data)
      that.optionMap.geo.map = 'china'
      that.chartDom.setOption(that.optionMap)
    })
  },
  reFreshMap: function (paramsName) {
    let that = this
    this.loadingObj.showLoading({
      title: '正在加载...'
    })
    if (that.tag === 0) {
      this.provinceOrCityName = paramsName
      let provinceEngName = provinceNameChineseToEng(this.provinceOrCityName)
      $.get('https://orangleli.github.io/imagesResources/echartMapResources/geoProvince/' + provinceEngName + '.json', function (mapJson) {
        that.tag++
        that.loadingObj.hideLoading()
        that.optionMap.series[0].data = convertData(data, provinceEngName)
        that.optionMap.geo.map = provinceEngName
        echarts.registerMap(provinceEngName, mapJson)
        that.chartDom.setOption(that.optionMap)
      })
      this.lastProvinceOrCityName = this.provinceOrCityName
    } else if (that.tag === 1) {
      if (this.lastProvinceOrCityName.includes('直辖市') > 0 || this.lastProvinceOrCityName.includes('台湾省') > 0) {
        that.loadingObj.hideLoading()
        return
      }
      this.provinceOrCityName = paramsName
      var provinceEngName = provinceNameChineseToEng(this.lastProvinceOrCityName)
      let cityNameEng = cityNameChineseToEng(that.provinceOrCityName, provinceEngName)
      $.get('https://orangleli.github.io/imagesResources/echartMapResources/city/' + provinceEngName + '/' + cityNameEng + '.json', function (mapJson) {
        that.tag++
        that.loadingObj.hideLoading()
        that.optionMap.series[0].data = convertData(data, provinceEngName, cityNameEng)
        that.optionMap.geo.map = provinceEngName
        echarts.registerMap(provinceEngName, mapJson)
        that.chartDom.setOption(that.optionMap)
      })
    } else {
      that.loadingObj.hideLoading()
    }
  },
  async init() {
    let mapData = []

    const res = await findAllAndCount()
    console.log(res)
    res.data.cloudlsdCountAreaList.forEach((item, index) => {
      const { region, areaAmount } = item
      mapData.push({ name: region, value: areaAmount })
    })

    this.setMap(mapData, res.data.count)
    this.setClick()


  },

}
export {
  MapDrillDown,
}
